/**
 * Gets group param from query params
 * @returns {string}
 */
export function getGroupIdFromParams() {
  const params = new URLSearchParams(window.location.search)
  let paramGroupId = '13' // Default to group 13

  if (params.get('l')) {
    try {
      const decodedUrl = atob(params.get('l') || '')
      const groupsMatch = decodedUrl.match(/groups=([^&]*)/)

      // Set group from URL, fallback to 13 if not found
      paramGroupId = groupsMatch ? groupsMatch[1] : '13'
    } catch (error) {
      console.warn('Error decoding base64 URL parameter:', error)
    }
  }

  if (params.get('vs_id') && params.get('g')) {
    paramGroupId = params.get('g') || '2'
  }

  // Handle group parameter (if no vs_id and no e parameter)
  if (params.get('g') && !params.get('vs_id') && !params.get('e')) {
    paramGroupId = params.get('g') || '2'
  }

  return paramGroupId
}
